export const ExploreIcon = (props: any) => {
  return (
    <svg
      className={props.className}
      width="14"
      height="17"
      viewBox="0 0 14 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.00005 1.26316C9.66672 1.26316 11.8889 3.36842 11.8889 5.89474C11.8889 8.42105 9.66672 10.5263 7.00005 10.5263C4.33339 10.5263 2.11117 8.42105 2.11117 5.89474C2.11117 3.36842 4.33339 1.26316 7.00005 1.26316ZM7.00005 0C3.53339 0 0.777832 2.61053 0.777832 5.89474C0.777832 9.17895 3.53339 11.7895 7.00005 11.7895C10.4667 11.7895 13.2223 9.17895 13.2223 5.89474C13.2223 2.61053 10.4667 0 7.00005 0Z"
        fill="#34363E"
      />
      <path
        d="M8.68878 13.896L8.42211 14.7381H5.57767L5.311 13.896H8.68878ZM10.5554 12.6328H3.44434L4.59989 16.0012H9.311L10.5554 12.6328Z"
        fill="#34363E"
      />
    </svg>
  );
};
